<template>
    <section class="shadow-lg p-4 gap-1.5 bg-white rounded-lg w-80">
        <Handle type="target" :position="Position.Left" />
        <article class="flex items-center gap-2">
            <article class="bg-primary-950 rounded-md p-2 inline-block">
                <Icon icon="mingcute:question-line" class="text-xl text-white"/>
            </article>
            <input type="text" placeholder="Field Name" v-model="data.name" 
                   class="block font-bold text-sm w-full outline-none border p-2 rounded-lg"/>
        </article>
        
        <textarea type="text" placeholder="Description" v-model="data.text" rows="5" cols="40"
                  class="block text-xs w-full outline-none p-2 border rounded-lg mt-2 text-gray-500"></textarea>

        <Handle type="source" :position="Position.Right" />
    </section>
</template>

<script setup>
import { ref } from "vue"
import { Icon } from "@iconify/vue"
import { Handle, Position } from '@vue-flow/core'

const data = ref({
    name: null,
    text: null,
});
</script>